var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Accordion as BaseAccordion } from '@base-ui-components/react';
import { v2Colors } from "../../tokens/color";
const styles = {
    padding: '0.8rem',
    border: `1px solid ${v2Colors.border.primary}`,
    borderRadius: '8px',
    '&:focus-within': {
        borderColor: v2Colors.border.activePrimary,
    },
};
/**
 * Contains all the parts of a collapsible section for the Accordion.
 *
 * @example
 * <AccordionItem>
 *      <AccordionTrigger>{item.value}</AccordionTrigger>
 *      <AccordionPanel>{iten.description}</AccordionPanel>
 * </AccordionItem>
 *
 */
export function AccordionItem(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(BaseAccordion.Item, Object.assign({ css: styles }, props, { children: children })));
}
